import { FC, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { PageTitle } from '../../../_metronic/layout/core'
import { fetchData, getTranslatedValue, toasterrormsg, toastsuccessmsg } from '../../../reusable';
import { ToastContainer } from 'react-toastify';
import { Tr } from '../../../_metronic/i18n/Tr';
import Select from 'react-select';
import { useLang } from '../../../_metronic/i18n/Metronici18n';

const AddHelpAndSupport: FC = () => {

    const t = Tr()
    const lang = useLang()
    const navigate = useNavigate()
    var vendorId = "";
    const vendorData = sessionStorage.getItem("vendor");
    if (vendorData) {
        var vendor = JSON.parse(vendorData);
        vendorId = vendor.vendorId;
    } else {
        console.log("No vendor data found");
    }
    const [loading, setLoading] = useState(false)
    const [disable, setDisable] = useState(false);
    const [subject, setSubject] = useState("");
    const [helpandsupportsubjectId, setHelpandsupportsubjectId] = useState("");
    const [description, setDescription] = useState("");
    const [subjectList, setSubjectList] = useState([])

    // set error state
    const [error, setError] = useState([{
        subject: '',
        description: '',
    }])

    // remove validation function
    const removeError = (err: any) => {
        var tmp = [...error] as any;
        tmp[0][err] = "";
        setError(tmp);
    }

    // validation function
    const validate = () => {

        var isValid = true;
        var errorTmp = [...error];

        if (!subject.trim() || !helpandsupportsubjectId) {
            errorTmp[0].subject = t('Subject Is Required');
            isValid = false;
        }
        if (!description.trim()) {
            errorTmp[0].description = t('Description Is Required');
            isValid = false;
        } else if (description.length > 5000) {
            errorTmp[0].description = t('Description Is Too Long');
            isValid = false;
        }
        setError(errorTmp);
        return isValid;
    }
    // add hotel api call
    const addHelpAndSupportApi = async () => {

        if (validate()) {
            setDisable(true)
            setLoading(true);
            let param: any = {
                vendorId: String(vendorId),
                helpandsupportsubjectId: String(helpandsupportsubjectId),
                subject: subject,
                description: description,
            }

            var res = await fetchData("public/savesupport", param)
            if (res.status == "200") {
                toastsuccessmsg(res.message || t("Help & Support Saved Successfully!"))
                setTimeout(() => {
                    navigate("../viewhelpandsupport/");
                    setDisable(false)
                    setLoading(false);
                }, 2000);
            }
            else {
                toasterrormsg(res.message)
                setDisable(false)
                setLoading(false);
            }
        }
    }

    const subjectListApiCall = async () => {
        var res = await fetchData("public/viewsubject", {})
        if (res.status == "200") {
            const filterData = res.data.map((item: any) => (
                { label: getTranslatedValue(lang, item, '_title'), value: String(item.helpandsupportsubjectId), subject: item.en_title }
            ))
            setSubjectList(filterData)
        } else {
            toasterrormsg(res.message)
        }
    }
    useEffect(() => {
        subjectListApiCall()
    }, []);
    return (
        <>
            <ToastContainer />
            <PageTitle breadcrumbs={[]}>{t('Add Help & Support Request')}</PageTitle>
            <div className="d-flex flex-column flex-column-fluid">
                {/* <!--begin::Content--> */}
                <div id="kt_app_content" className="app-content flex-column-fluid">
                    {/* <!--begin::Form--> */}
                    <div className="form d-flex flex-column flex-lg-row">
                        {/* <!--begin::Main column--> */}
                        <div className="d-flex flex-column flex-row-fluid gap-7 gap-lg-10">
                            <div className="d-flex flex-column">
                                {/* <!--begin::General options--> */}
                                <div className="card card-flush py-4">
                                    {/* <!--begin::Card body--> */}
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-lg-3"></div>
                                            <div className="col-lg-6 my-3">
                                                {/* <!--begin::Label--> */}
                                                <label className="required fs-4 form-label">{t('Subject')}</label>
                                                {/* <!--end::Label--> */}
                                                {/* <!--begin::Input--> */}
                                                <Select
                                                    name={`subject`}
                                                    id={`subject`}
                                                    placeholder={t('Select')}
                                                    isSearchable={true}
                                                    options={subjectList}
                                                    value={subjectList.find(
                                                        (option: any) => option.value == helpandsupportsubjectId
                                                    ) || ''}
                                                    onChange={(e: any) => { setHelpandsupportsubjectId(e.value); setSubject(e.subject); removeError("subject"); }}
                                                />
                                                {/* <!--end::Input--> */}
                                                <div className='text-danger fw-bold'>{error[0].subject}</div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-3"></div>
                                            <div className="col-lg-6 my-3">
                                                {/* <!--begin::Label--> */}
                                                <label className="required fs-4 form-label">{t('Description')}</label>
                                                {/* <!--end::Label--> */}
                                                {/* <!--begin::Input--> */}
                                                <textarea name="description" className="form-control mb-2" placeholder={t("Description")} value={description} onChange={(e) => { setDescription(e.target.value); removeError("description"); }} />
                                                {/* <!--end::Input--> */}
                                                <div className='text-danger fw-bold'>{error[0].description}</div>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-end">
                                            {/* <!--begin::Button--> */}
                                            <Link to="../viewhelpandsupport/" className="btn btn-light me-5">{t('Cancel')}</Link>
                                            {/* <!--end::Button--> */}
                                            <button type="button" disabled={disable} className="btn btn-primary" onClick={addHelpAndSupportApi}>
                                                <span className="indicator-label">{t('Submit')}</span>
                                                {loading && (
                                                    <span className="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
                                                )}
                                            </button>
                                            {/* <!--end::Button--> */}
                                        </div>
                                    </div>
                                </div>
                                {/* <!--end::Pricing--> */}
                            </div>
                        </div>
                        {/* <!--end::Main column--> */}
                    </div>
                    {/* <!--end::Form--> */}
                </div>
                {/* <!--end::Content--> */}
            </div>
        </>
    )
}

export { AddHelpAndSupport }
